import React from "react";
import { useEffect, useState } from "react";
import { usePageState } from "../../Layout";
import { apiUrl, executeRequest, getToken } from "../../functions/requests";
import List from "../../components/List";
import Popup from "../../components/Popup";
import Button from "../../components/Button";
import RightSidebar from "../../components/RightSidebar";
import Spacer from "../../components/Spacer";

export default function KnowledgeBaseTrash({ onActionExecuted }) {
  const { pageState, setPageState } = usePageState();
  const [userData, setUserData] = useState(pageState.userData);

  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [recordToView, setRecordToView] = useState(null);

  // Get all records in knowledge base and store them to page state
  const getTrashedRecords = async () => {
    setLoading(true);
    await executeRequest(
      apiUrl + "knowledge-base-records?trash=yes",
      "GET",
      null,
      {
        Authorization: "Bearer " + getToken(),
      },
      (data) => {
        setRecords(data);
      },
      (error) => {}
    );
    setLoading(false);
  };

  // Revert record deletion
  const revertRecord = async (item) => {
    if (userData.uuid !== item.owner.uuid) return;
    setLoading(true);
    await executeRequest(
      apiUrl + "knowledge-base-records/revert/" + item.uuid,
      "DELETE",
      null,
      {
        Authorization: "Bearer " + getToken(),
      },
      (data) => {
        onActionExecuted();
      },
      (error) => {}
    );
    setLoading(false);
  };

  // Permanently delete record
  const confirmDeletion = async (item) => {
    if (userData.uuid !== recordToDelete.owner.uuid) return;
    setLoading(true);
    await executeRequest(
      apiUrl + "knowledge-base-records/confirm/" + recordToDelete.uuid,
      "DELETE",
      null,
      {
        Authorization: "Bearer " + getToken(),
      },
      (data) => {
        onActionExecuted();
      },
      (error) => {}
    );
    setLoading(false);
  };

  // Empty all trash belonging to current user
  const emptyTrash = async () => {
    setLoading(true);
    await executeRequest(
      apiUrl + "knowledge-base-records/empty",
      "DELETE",
      null,
      {
        Authorization: "Bearer " + getToken(),
      },
      (data) => {
        onActionExecuted();
      },
      (error) => {}
    );
    setLoading(false);
  };

  // Get initial records
  useEffect(() => {
    getTrashedRecords();
  }, []);

  return (
    <div>
      <h1 className="page-title">Trashed Records</h1>
      <List
        itemType="knowledge-base-record-trashed"
        items={records}
        headers={[
          "Name",
          "Type",
          "Description",
          "Owner",
          "Created at",
          "Updated at",
          "Deleted at",
        ]}
        isLoading={loading}
        onView={(item) => setRecordToView(item)}
        onReset={(item) => revertRecord(item)}
        onDelete={(item) =>
          userData.uuid === item.owner.uuid ? setRecordToDelete(item) : null
        }
      />
      {recordToView !== null && (
        <RightSidebar
          active={true}
          content={
            <div>
              <div>Name: {recordToView.name}</div>
              <div>Type: {recordToView.type}</div>
              <div>
                Owner: {recordToView.owner.first_name}{" "}
                {recordToView.owner.last_name}
              </div>
              <div>Created at: {recordToView.created_at}</div>
              <div>Updated at: {recordToView.updated_at}</div>
              <div>Deleted at: {recordToView.marked_as_deleted_at}</div>
            </div>
          }
        />
      )}
      {recordToDelete !== null && (
        <Popup
          isActive={true}
          onClosed={() => setRecordToDelete(null)}
          title={`Delete record ${recordToDelete.name}?`}
          content={
            <>
              <div>
                This action is irreversible. Are you sure you wish to continue?
              </div>
              <Spacer />
              <div className="flex flex-gap-m flex-justify-center">
                <Button
                  type="success"
                  text="Confirm"
                  onClicked={() => confirmDeletion()}
                />
                <Button
                  type="danger"
                  text="Cancel"
                  onClicked={() => setRecordToDelete(null)}
                />
              </div>
            </>
          }
        />
      )}
    </div>
  );
}
